import { createUrl } from '@/utils';

const places = createUrl('places');

const cashRegisters = places('cash-registers');

export const placesEndpoints = { cashRegisters };
